exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.series-stock .hide {\n  display: none !important;\n}\n.series-stock div[col-id='checked'] {\n  pointer-events: all !important;\n}\n.series-stock .estilo-grilla,\n.series-stock #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.series-stock .ag-pinned-left-cols-container,\n.series-stock .ag-header .ag-pinned-left-header,\n.series-stock .ag-body-horizontal-scroll .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
